import React from 'react';
import { ToolSubmenu } from './ToolSubmenu';
import { SCENE_LOOK_GROUPS, SCENE_LOOKS, looksInGroup, resolveSceneLook } from '../../Utils/sceneLooks';

export default function SceneLookStrip({
  open,
  layout = 'row',
  sceneLookId,
  onSceneLookChange,
  onClose,
}) {
  if (!open) return null;

  const isColumn = layout === 'column';
  const current = resolveSceneLook(sceneLookId);

  return (
    <ToolSubmenu layout={layout} label="Studio" onClose={onClose}>
      <div className={isColumn ? 'flex flex-col gap-2 w-full' : 'flex items-center gap-2 min-w-0 flex-1'}>
        <label className={`relative shrink-0 ${isColumn ? 'w-full' : 'w-[11.5rem]'}`}>
          <span className="sr-only">Scene lighting look</span>
          <select
            value={current.id}
            onChange={(e) => onSceneLookChange?.(e.target.value)}
            className="m-0 h-7 w-full appearance-none rounded-sm border border-yellow-600/40 bg-zinc-950 pl-2 pr-7 text-[10px] font-semibold uppercase tracking-[0.08em] text-yellow-400 outline-none hover:border-yellow-400 focus:border-yellow-400"
            title="Scene lighting look"
          >
            {SCENE_LOOK_GROUPS.map((group) => (
              <optgroup key={group} label={group}>
                {looksInGroup(group).map((look) => (
                  <option key={look.id} value={look.id}>
                    {look.label}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
          <svg
            viewBox="0 0 12 12"
            className="pointer-events-none absolute right-2 top-1/2 h-2.5 w-2.5 -translate-y-1/2 text-yellow-500/80"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            aria-hidden
          >
            <path d="M2 4l4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </label>

        <p
          className={`text-[10px] text-zinc-400 leading-snug ${
            isColumn ? 'w-full' : 'hidden lg:block max-w-[16rem] shrink'
          }`}
        >
          {current.description}
        </p>

        <div
          className={
            isColumn
              ? 'flex flex-col gap-1.5 w-full'
              : 'flex items-stretch gap-1.5 min-w-0 overflow-x-auto scrollbar-none'
          }
        >
          {SCENE_LOOKS.map((look) => {
            const active = look.id === current.id;
            return (
              <button
                key={look.id}
                type="button"
                title={look.description}
                onClick={() => onSceneLookChange?.(look.id)}
                className={`m-0 shrink-0 rounded-sm border px-2 py-1.5 text-left transition-colors ${
                  isColumn ? 'w-full' : 'w-[9.25rem]'
                } ${
                  active
                    ? 'border-yellow-400 bg-yellow-500/15 text-yellow-200'
                    : 'border-yellow-600/25 bg-black/40 text-zinc-300 hover:border-yellow-500/50 hover:bg-yellow-500/5'
                }`}
              >
                <span className="flex items-center justify-between gap-1">
                  <span className="text-[10px] font-semibold uppercase tracking-[0.08em] text-yellow-400">
                    {look.label}
                  </span>
                  <span className="text-[8px] uppercase tracking-wider text-zinc-500">{look.group}</span>
                </span>
                <span className="mt-0.5 block text-[9px] leading-snug text-zinc-400 line-clamp-3">{look.description}</span>
              </button>
            );
          })}
        </div>
      </div>
    </ToolSubmenu>
  );
}
